import script from "./SogSvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogSvgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SogSvgIcon.vue?vue&type=style&index=0&id=e7498346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7498346"]])

export default __exports__